module.exports = __webpack_public_path__ + "static/media/country_codes_dialing_A2.4b2bb1e7.csv";